import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';

import Header from '@/components/site/Header';
import Hero from '@/components/site/Hero';
import About from '@/components/site/About';
import Services from '@/components/site/Services';
import Departments from '@/components/site/Departments';
import WhyUs from '@/components/site/WhyUs';
import Contact from '@/components/site/Contact';
import Footer from '@/components/site/Footer';

const Home = () => (
  <div className="bg-cream">
    <Header />
    <main>
      <Hero />
      <About />
      <Services />
      <Departments />
      <WhyUs />
      <Contact />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
